/**
 * @generated SignedSource<<774a25670997f2ca566a8b3704e4bd4e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StandaloneSiteStatus = "ACTIVE" | "DISABLED" | "DRAFT";
export type salesChannelMiniSitesQuery$variables = Record<PropertyKey, never>;
export type salesChannelMiniSitesQuery$data = {
  readonly standaloneSites: ReadonlyArray<{
    readonly domain: string | null;
    readonly id: string;
    readonly name: string;
    readonly standaloneSiteID: number;
    readonly status: StandaloneSiteStatus;
  }>;
};
export type salesChannelMiniSitesQuery = {
  response: salesChannelMiniSitesQuery$data;
  variables: salesChannelMiniSitesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StandaloneSiteInfo",
    "kind": "LinkedField",
    "name": "standaloneSites",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "standaloneSiteID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "domain",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelMiniSitesQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "salesChannelMiniSitesQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "2d62d61a0de816f2e48f637049437ff6",
    "id": null,
    "metadata": {},
    "name": "salesChannelMiniSitesQuery",
    "operationKind": "query",
    "text": "query salesChannelMiniSitesQuery {\n  standaloneSites {\n    id\n    standaloneSiteID\n    name\n    domain\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "2e530821b9de019125c40edf3b31722b";

export default node;
